const USER_INFO_LOCATION_ENDPOINT = 'https://userinfo-staging.paessler.com/api/location';
const CURRENCIES = {
	EUR: 'eur',
	USD: 'usd',
};
const SELECTOR_PRICE_LIST = '[data-price-list]';
const SELECTOR_FEATURE_LIST = '[data-feature-list]';
const SELECTOR_PRICE = '[data-price]';
const SELECTOR_CURRENCY_SYMBOL = '[data-currency-symbol]';

document.addEventListener('DOMContentLoaded', function () {
	let lists = document.querySelectorAll(SELECTOR_PRICE_LIST + ', ' + SELECTOR_FEATURE_LIST);
	let prices = document.querySelectorAll(SELECTOR_PRICE);
	if (!lists && !prices) {
		return;
	}

	initCurrency(lists);
});

function initCurrency(lists) {
	fetch(USER_INFO_LOCATION_ENDPOINT)
		.then(function (response) {
			return response.text();
		})
		.then(function (resultJson) {
			let result = JSON.parse(resultJson);

			if (result?.CountryCode && isEuCountry(result.CountryCode)) {

				lists.forEach((list) => {
					list.dataset.currency = CURRENCIES.EUR;
				});
				changePrices(CURRENCIES.EUR);

				changeCurrencySymbols(CURRENCIES.EUR);
			}
		});
}

function changePrices(currency) {
	let prices = document.querySelectorAll(SELECTOR_PRICE);

	if (!prices) {
		return;
	}

	prices.forEach((price) => changePrice(price, currency));
}

function changePrice(priceElement, currency) {
	let dataAttributeCurrency = 'data-' + currency;

	if(priceElement.getAttribute(dataAttributeCurrency + '-symbol')){
		const dataSymbolCurrency = dataAttributeCurrency + '-symbol'

		priceElement.innerHTML = priceElement.getAttribute(dataSymbolCurrency) + ' ' + priceElement.getAttribute(dataAttributeCurrency)
	} else {
		priceElement.innerHTML = priceElement.getAttribute(dataAttributeCurrency);
	}
}

function changeCurrencySymbols(currency) {
	let currencySymbols = document.querySelectorAll(SELECTOR_CURRENCY_SYMBOL);
	if (!currencySymbols) {
		return;
	}

	currencySymbols.forEach((currencySymbol) => changeCurrencySymbol(currencySymbol, currency));
}

function changeCurrencySymbol(currencySymbolElement, currency) {
	let dataAttributeCurrency = 'data-' + currency;

	currencySymbolElement.innerHTML = currencySymbolElement.getAttribute(dataAttributeCurrency);
}

function isEuCountry(countryCode) {
	/*
	Euro countries:
	Andorra, Albania, Austria, Åland, Bosnia-Herzegovina, Belgium, Bulgaria, Switzerland,
	Czech Republic, Germany, Denmark, Estonia, Spain, Finland, France, Great Britain,
	French Guyana, Guernsey, Gibraltar, Greece, Croatia, Hungary, Canary Islands,
	Ireland, Isle of Man, Iceland, Italy, Jersey, Liechtenstein, Lithuania, Luxembourg, Latvia,
	Monaco, Montenegro, North Macedonia, Martinique, Malta, New Caedonia, Netherlands, Norway,
	Poland, Saint Pierre and Miquelon, Portugal, Reunion, Romania, Serbia, Sweden, Slovenia,
	Slovak Republic, San Marino, French Southern Territories, Turkey, United Kingdom, Vatican City State, Wallis and Futuna, Mayotte
	https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	*/
	let euroCountries = [
		'AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'CH',
		'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB',
		'GF', 'GG', 'GI', 'GP', 'GR', 'HR', 'HU', 'IC',
		'IE', 'IM', 'IS', 'IT', 'JE', 'LI', 'LT', 'LU', 'LV',
		'MC', 'ME', 'MK', 'MQ', 'MT', 'NC', 'NL', 'NO',
		'PL', 'PM', 'PT', 'RE', 'RO', 'RS', 'SE', 'SI',
		'SK', 'SM', 'TF', 'TR', 'UK', 'VA', 'WF', 'YT',
	];

	return euroCountries.includes(countryCode);
}
